module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_yq_stgl.51b30caf.png";